// Validadores y normalizadores puros para las reglas de negocio que se
// repiten en más de un formulario. La fuente de verdad de la REGLA sigue
// siendo la base de datos (constraints, índices únicos parciales — ver
// diseno-base-datos-saas-tiendas-peru.md, 5.5); esto es solo la capa de
// validación temprana en el cliente, para no obligar a un roundtrip al
// servidor por cada error de formato.

const REGEX_SLUG = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * Slug y subdominio comparten exactamente la misma forma válida (ver 5.2 y
 * 5.5 del doc de BD: minúsculas, dígitos y guiones, sin guion al inicio/fin
 * ni repetidos), así que una sola regex las valida a ambas.
 *
 * @param {string} valor
 * @returns {boolean}
 */
export function esSlugValido(valor) {
  return typeof valor === 'string' && REGEX_SLUG.test(valor);
}

/**
 * Subdominio válido — alias semántico de `esSlugValido`. Se mantiene como
 * función aparte (aunque hoy sea idéntica) porque las reglas de negocio de
 * "slug" (usado en rutas de JSON) y "subdominio" (usado en DNS) podrían
 * divergir a futuro (ej. límite de longitud distinto por restricciones de
 * DNS) sin que eso deba forzar un cambio de firma en los formularios que ya
 * llaman a esta función.
 *
 * @param {string} valor
 * @returns {boolean}
 */
export function esSubdominioValido(valor) {
  return esSlugValido(valor);
}

/**
 * Convierte un texto libre (ej. "Mi Tienda Bonita S.A.C.") en un slug
 * candidato ("mi-tienda-bonita-s-a-c"). Es solo una sugerencia de UX para
 * pre-llenar el campo de slug/subdominio en el formulario de alta de
 * empresa — el usuario puede editarlo, y `esSlugValido` sigue siendo quien
 * decide si el resultado final es aceptable.
 *
 * @param {string} texto
 * @returns {string}
 */
export function generarSlugSugerido(texto) {
  return String(texto)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // quita tildes/diacríticos
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');
}

/**
 * Validación de formato de correo suficiente para feedback temprano en UI.
 * La validación real/autoritativa la hace Supabase Auth al crear el
 * usuario — esto nunca debe usarse como única línea de defensa.
 *
 * @param {string} valor
 * @returns {boolean}
 */
export function esCorreoValido(valor) {
  return typeof valor === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);
}
